import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

/* Actions */
import { Logout } from 'src/app/core/store/auth/auth.action';

@Component({
	selector: 'app-main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
	isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet]).pipe(
		map((result) => result.matches),
		shareReplay(),
	);

	constructor(private breakpointObserver: BreakpointObserver, private store: Store) {}

	onLogout() {
		this.store.dispatch(new Logout());
	}
}
